import { render, staticRenderFns } from "./IMPayment.vue?vue&type=template&id=3f3c98ba&lang=pug"
import script from "./IMPayment.vue?vue&type=script&lang=js"
export * from "./IMPayment.vue?vue&type=script&lang=js"
import style0 from "./IMPayment.vue?vue&type=style&index=0&id=3f3c98ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports